import {Button, styled} from "@mui/material";

export const DialogCancelButton = styled(Button)(({theme}) => ({
    backgroundColor: '#fff',
    color: theme.barekam.recipient.buttons.cancel.color,
    display: 'flex',
    padding: '0.75rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
    border: '1px solid #CFCFE0',
    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.cancel.backgroundColor,
    }
}));

export const DialogSaveButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    color: theme.barekam.recipient.buttons.add.color,

    display: 'flex',
    padding: '0.75rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
    gap: '0.75rem',

    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    }
}));

export const DialogDeleteButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.barekam.recipient.buttons.delete.backgroundColor,
    color: theme.barekam.recipient.buttons.add.color,

    display: 'flex',
    padding: '0.75rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
    gap: '0.75rem',

    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.delete.backgroundColor,
    }
}));

export const DialogOkButton = styled(Button)(({theme}) => ({
    color: theme.barekam.text.regular,

    display: 'flex',
    padding: '0.75rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.5rem',
    gap: '0.75rem',
    border: '1px solid #CFCFE0'
}));